import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Note extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Note'
  // Define default properties here
  static instanceDefaults() {
    return {
      message_id: null,
      user_id: null,
      note: null,
      properties: {},
      created_at: null
    }
  }
}

const servicePath = 'notes'
const servicePlugin = makeServicePlugin({
  Model: Note,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin